import React, { useContext, useEffect, useState } from 'react';
import * as Yup from 'yup';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import LoadingButton from '@mui/lab/LoadingButton';
import FormControl from '@mui/material/FormControl';
import HttpService from '../../../hooks/Https-services';
import PAGE_ROUTES, {
  API_ROUTES,
  permissions,
  UserPermissions,
} from '../../../utils/constant';
import { GlobalSearchContext } from '../../../context/GlobalSearchContext';
import {
  Autocomplete,
  Backdrop,
  Button,
  CircularProgress,
  InputLabel,
  TextField,
  Typography,
} from '@mui/material';
import { toast } from 'react-toastify';
import { Field, Form, Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import useCommonDetails from '../../../hooks/useCommonDetails';

interface UserInfo {
  shiftId: string | null;
  roleId: number;
  teamId: number;
  name: string;
  email: string;
  password: string;
  middleName?: any;
  teamLeadId?: any;
}
export default function AddTPEUser() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const details = useCommonDetails();

  const {
    handleSearchChangeTag,
    debouncedQueryTag,
    _searchQueryTag: sQueryTag,
  }: any = useContext(GlobalSearchContext);

  const [selectAssign, setSelectAssign] = React.useState<any | null>(null);

  const [userInfo, setUserInfo] = useState<any[]>([]);

  const [optionsTagger, setOptionsTagger] = useState<
    { label: string; id: number }[]
  >([]);

  const fetchUserList = React.useCallback(async () => {
    try {
      setLoading(true);
      const query: any = {
        search: sQueryTag,
        isTpeUser: false,
        roleId: 2,
      };

      const response = await HttpService.get(
        API_ROUTES.allUser + `?${new URLSearchParams(query).toString()}`
      );
      setUserInfo(response.data.data.list || []);
    } catch (error: any) {
      setLoading(false);
      console.error('Error fetching Tagger info:', error);
    } finally {
      setLoading(false);
    }
  }, [sQueryTag]);

  useEffect(() => {
    fetchUserList();
  }, [fetchUserList]);

  useEffect(() => {
    const optdata = userInfo?.map((el: any) => {
      return {
        label: el.name,
        id: el.id,
        middleName: el.middleName,
      };
    });
    setOptionsTagger(optdata);
  }, [userInfo]);

  const validationSchema = Yup.object().shape({
    tms_id: Yup.string().required('TMS user is required'),
    tpe_name: Yup.string().required('TPE Name is required'),
    tpe_id: Yup.number().required('TPE Id is required'),
  });

  const onClose = () => {
    navigate(PAGE_ROUTES.USERS);
  };

  return (
    <Box sx={{ margin: 2 }}>
      <Formik
        initialValues={{
          tms_id: '',
          tpe_name: '',
          tpe_id: '',
        }}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={async (values) => {
          const payload = {
            tms_id: values.tms_id,
            tpe_id: values.tpe_id,
            tpe_name: values.tpe_name,
          };
          try {
            await HttpService.post(API_ROUTES.tpeRegisterUser, payload);
            toast.success('Register Successfully', {
              position: 'bottom-right',
            });
            navigate(PAGE_ROUTES.USERS);
          } catch (error) {
            console.error(error);
            // navigate(PAGE_ROUTES.USERS);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          isSubmitting,
          isValid,
          setFieldValue,
        }) => {
          return (
            <Form>
              <Card sx={{ p: 3 }}>
                <Box
                  rowGap={3}
                  columnGap={2}
                  display="grid"
                  gridTemplateColumns={{
                    xs: 'repeat(1, 1fr)',
                    sm: 'repeat(2, 1fr)',
                  }}
                  sx={{ marginTop: '10px' }}
                >
                  <FormControl>
                    <Autocomplete
                      size="medium"
                      fullWidth
                      id="disable-clearable"
                      isOptionEqualToValue={(option, value) =>
                        option.id === value?.id
                      } // Compare by id for selected item
                      onClose={() => {
                        const data = {
                          target: {
                            value: '',
                          },
                        };
                        handleSearchChangeTag(data);
                      }}
                      value={selectAssign}
                      options={optionsTagger}
                      renderOption={(props: any, option: any) => {
                        return (
                          <Box component="li" {...props} key={option?.id}>
                            <Typography
                              variant="body1"
                              sx={{
                                fontStyle: 'normal',
                                textTransform: 'none',
                              }}
                            >
                              {' '}
                              {UserPermissions[details.isDesabled]?.includes(
                                permissions.PARENTUSER
                              )
                                ? `${option?.label} (${option?.middleName})`
                                : option?.label}
                            </Typography>
                          </Box>
                        );
                      }}
                      onChange={(event, newValue: any) => {
                        setSelectAssign(newValue);
                        setFieldValue(
                          'tms_id',
                          newValue?.id ? String(newValue.id) : ''
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          value={debouncedQueryTag}
                          onChange={(e) => handleSearchChangeTag(e)}
                          margin="normal"
                          placeholder="Select User"
                        />
                      )}
                    />
                  </FormControl>
                  <Field
                    name="tpe_name"
                    as={TextField}
                    label="TPE Name"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    helperText={
                      touched.tpe_name && errors.tpe_name
                        ? (errors.tpe_name as string)
                        : null
                    }
                    error={touched.tpe_name && !!errors.tpe_name}
                  />
                  <Field
                    name="tpe_id"
                    as={TextField}
                    label="TPE Id"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    helperText={
                      touched.tpe_id && errors.tpe_id
                        ? (errors.tpe_id as string)
                        : null
                    }
                    error={touched.tpe_id && !!errors.tpe_id}
                  />
                </Box>
                <Stack
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginTop: 2,
                    gap: 2,
                    justifyContent: 'flex-end',
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{ whiteSpace: 'nowrap' }}
                  >
                    Cancel
                  </Button>
                  <LoadingButton
                    type="submit"
                    variant="contained"
                    loading={isSubmitting}
                    disabled={isSubmitting || !isValid}
                  >
                    Create TPE User
                  </LoadingButton>
                </Stack>
              </Card>
            </Form>
          );
        }}
      </Formik>

      {/* Backdrop with CircularProgress for loader */}
      <Backdrop
        sx={(theme) => ({
          color: '#fff',
          zIndex: theme.zIndex.drawer + 1,
        })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
}
